var _rect, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignInRequired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1200,
    width: 1600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    opacity: 0,
    width: 1600,
    height: 1200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1359.66 464.16C1348.55 431.02 1330.9 400.66 1306.24 376.27 1218.6 289.41 1081.63 283.13 971.17 315.04 935.01 325.53 900.3 341.49 867.06 359.5 839.08 374.63 811.88 391.19 783.22 404.57 750.66 418.16 717.03 427.83 682.52 433.49 647.13 437.71 611.45 437.92 576.06 433.7 544.28 428.25 513.48 417.34 481.69 412.29 444.36 406.43 406.83 407.66 371.24 422.79 337.32 437.1 306.12 457.78 281.46 486.7 255.43 517.27 236.61 553.19 225.89 592.61 205.03 669.79 215.17 756.14 249.29 827.46 266.74 863.79 294.42 896.62 327.96 917 367.25 941.09 412.97 947.57 456.84 935.63 498.75 924.1 538.24 899.09 576.84 878.82 619.54 856.59 670.04 817.17 718.88 815.94 757 814.91 794.92 837.14 830.11 850.11 872.03 865.65 916.09 872.13 960.45 871.51 999.74 870.9 1038.93 866.26 1077.83 861.43 1175.7 849.49 1275.63 827.67 1337.24 738.54 1391.63 659.81 1400.02 551.44 1359.66 464.16Z",
    fill: "#eeb681",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M892.38 1061.73H1314.73 1321.26C1347.05 1061.73 1368.07 1040.8 1368.07 1014.91 1368.07 989.12 1347.05 968.1 1321.26 968.1H1289.77",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.66 1061.73H881.3",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.93 1061.73H408.3",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.72 968.31H1196.87",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.28 968.31H1178.85",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M606.77 275.87H533.12C540.84 275.87 547.04 269.67 547.04 261.94 547.04 254.22 540.84 248.02 533.12 248.02H448.87 446.89 385.9C372.61 248.02 361.92 258.8 361.92 272 361.92 285.12 372.7 295.99 385.9 295.99H349.7C343.77 295.99 339.01 300.75 339.01 306.67 339.01 312.6 343.77 317.36 349.7 317.36H424.44 458.21 606.59C618.09 317.36 627.25 308.2 627.25 296.7 627.25 285.21 618.09 275.87 606.77 275.87Z",
    fill: "#e5e7eb",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.68 275.87H502.04",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.98 275.87H474.11",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.83 386.35C573.54 386.35 592.76 367.12 592.76 343.41 592.76 319.7 573.54 300.48 549.83 300.48 526.11 300.48 506.89 319.7 506.89 343.41 506.89 367.12 526.11 386.35 549.83 386.35Z",
    fill: "#c9d5ed",
    stroke: "#333333",
    strokeWidth: 2,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.44 357.51C286.38 357.51 272.64 343.77 272.64 326.7 272.64 309.64 286.38 295.9 303.44 295.9H317.55 400.72C406.65 295.9 411.41 300.66 411.41 306.58 411.41 312.51 406.65 317.27 400.72 317.27L414.02 317.09H440.87C452.01 317.09 461.08 326.08 461.08 337.3 461.08 348.44 452.1 357.51 440.87 357.51H303.44Z",
    fill: "#e5e7eb",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.25 317.18H360.84",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.8 358.05C311.8 373.95 298.86 386.26 282.97 386.26H239.31",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38 386.62H147.33",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.48 386.62H116.97",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1040.18 701.67V571.02H559.82V968.28H1040.18V766.99 701.67Z",
    fill: "#2990c7",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.57 783.11C851.03 772.14 859.84 755.19 859.84 735.58 859.84 702.5 833.08 675.74 800 675.74 766.92 675.74 740.16 702.5 740.16 735.58 740.16 755.02 749.47 772.48 764.26 783.45L748.14 862.73H852.36L836.57 783.11C836.24 783.45 836.24 783.45 836.57 783.11Z",
    fill: "#eec8a5",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.57 783.11C851.03 772.14 859.84 755.19 859.84 735.58 859.84 702.5 833.08 675.74 800 675.74 766.92 675.74 740.16 702.5 740.16 735.58 740.16 755.02 749.47 772.48 764.26 783.45L748.14 862.73H852.36L836.57 783.11ZM836.57 783.11C836.24 783.45 836.24 783.45 836.57 783.11Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1089.69 478.29C1087.21 478.29 1085.23 480.27 1085.23 482.75V522.15C1085.23 524.63 1087.21 526.61 1089.69 526.61 1092.17 526.61 1094.15 524.63 1094.15 522.15V508.77C1094.15 507.35 1095.2 506.29 1096.63 506.29H1101.18C1102.61 506.29 1103.66 507.35 1103.66 508.77V524.59C1103.66 527.07 1105.64 529.05 1108.12 529.05H1117.64C1120.12 529.05 1122.1 527.07 1122.1 524.59V496.31H1263.97C1267.97 510.61 1281.07 521.19 1296.7 521.19 1315.45 521.19 1330.58 506.06 1330.58 487.3 1330.58 468.64 1315.32 453.42 1296.7 453.42 1281.11 453.42 1267.97 464 1263.97 478.29H1089.69Z",
    fill: "#2990c7",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.13 482.98C1319.82 484.27 1320.19 485.79 1320.19 487.3 1320.19 492.22 1316.19 496.31 1311.18 496.31 1306.17 496.31 1302.17 492.32 1302.17 487.3 1302.17 482.39 1306.17 478.29 1311.18 478.29 1312.47 478.29 1313.66 478.52 1314.72 478.98",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInRequired);
export default __webpack_public_path__ + "static/media/sign-in-required.52b4c9e7478980392337a4b44cffeb83.svg";
export { ForwardRef as ReactComponent };